'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
interface SkeletonFieldProps {
  label: string;
  className?: string;
}

/**
 * Field-shaped skeleton with a static label above and a pulsing skeleton
 * bar where the value will land once the AI stream emits. Shared by:
 *   - `ai/ai-edit-form.tsx` (proposal creation streaming)
 *   - `suggested-outcomes/wizard/SuggestOutcomeWizard.tsx`
 *
 * Originally inline in ai-edit-form; lifted when the Suggested-outcomes
 * wizard adopted the same streamed-field pattern (#34 audit).
 */
export function SkeletonField(t0) {
  const $ = _c(7);
  const {
    label,
    className
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-caption font-medium">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `w-full rounded-control ${className ?? ""}`;
  let t3;
  if ($[2] !== t2) {
    t3 = <Skeleton className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className="flex flex-col gap-1.5">{t1}{t3}</div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}